import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "15", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "15", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Glasses";
const Glasses = memo(themed(Icon));
export {
  Glasses
};
//# sourceMappingURL=glasses.js.map
